import React from "react";
import Slider from "react-slick";
import "./AutoPlaytext.css";
import { IoCheckmarkSharp } from "react-icons/io5";
 

const titles = [
  {
    id: 1,
    title:"Free Onboarding",
  },
  {
    id: 2,
    title:"Free Support",
  },
  {
    id: 3,
    title:"Free Training",
  },
  {
    id: 4,
    title:"Free Demo",
  },
  {
    id: 5,
    title:"Free Resources",
  },{
    id:6,
    title:"Custom-Built Features"
  },{
    id:7,
    title:"Organisation Account"
  },{
    id:8,
    title:"Security Restrictions"
  }
];

function  AutoPlaytext() {
  const settings = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200, // Large screens
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992, // Medium screens (tablets)
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Small screens (portrait tablets)
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576, // Extra small screens (mobile)
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {titles.map((title) => (
          <div key={title.id} className="client-container-box">
            <span><IoCheckmarkSharp className="checkmark" />
            </span>
            <span  className={`title${title.id}`} >
            {
              title.title
            }

            </span>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default  AutoPlaytext;
